var uniq = require('lodash/array').uniq;
var filtersApplied = [];
var filtersSelected = [];
var filteredDealers = [];
var filterDistance = false;
var dealersAttributes = [];

function selectFilter(data) {
  var index = filtersSelected.indexOf(data.codes);

  if (index === -1) {
    filtersSelected.push(data.codes);
  }
}

function unselectFilter(data) {
  var index = filtersSelected.indexOf(data.codes);

  if (index !== -1) {
    filtersSelected.splice(index, 1);
  }
}

function checkAttributes(attribute) {
  var filter = this;
  var show = false;

  show = attribute.Code === filter.code;

  return show;
}

function checkCombinedFilter(filter) {
  var attributes = this;
  var show = false;

  show = attributes.some(checkAttributes, filter);

  return show;
}

function checkFilters(filter) {
  var show = false;
  var dealer = this;

  if (!Array.isArray(filter)) {
    show = dealer.Attributes.some(checkAttributes, filter);
  } else {
    show = filter.some(checkCombinedFilter, dealer.Attributes);
  }

  return show;
}

function checkDealer(dealer) {
  var show = false;
  var inRadius = dealer.DrivingDistanceMiles <= parseInt(filterDistance, 10);

  if (!filterDistance || (filterDistance && inRadius)) {
    if (filtersApplied.length > 0) {
      show = filtersApplied.every(checkFilters, dealer);
    } else {
      show = true;
    }
  } else {
    show = false;
  }

  if (show) {
    filteredDealers.push(dealer);
  }
}

function checkIfFilterIsInSearch(previous, filter) {
  var isInArray = filter.alwaysShown ? true : dealersAttributes.indexOf(filter.code) !== -1;

  return isInArray;
}

function mapFilterInSearch(filter) {
  var isInSearch = true;

  if (filter.length > 1) {
    isInSearch = filter.reduce(checkIfFilterIsInSearch, true);
  } else {
    isInSearch = checkIfFilterIsInSearch(true, filter[0]);
  }

  return isInSearch;
}

function checkFiltersAndAttributes(filtersArray) {
  var newFiltersApplied = filtersArray;

  newFiltersApplied = newFiltersApplied.filter(mapFilterInSearch);

  return newFiltersApplied;
}

function filterDealers(dealers, distance) {
  filteredDealers = [];
  filterDistance = distance;
  filtersApplied = checkFiltersAndAttributes(filtersSelected.slice(0));

  if (filtersApplied.length > 0 || filterDistance) {
    dealers.map(checkDealer);
  } else {
    filteredDealers = dealers;
  }

  return filteredDealers;
}

function getFilters() {
  return { applied: checkFiltersAndAttributes(filtersApplied), distance: filterDistance };
}

function getFilter(codes) {
  var index = filtersApplied.indexOf(codes);
  var isApplied = false;

  if (index !== -1) {
    isApplied = true;
  }

  return isApplied;
}

function resetFilters() {
  filtersApplied = [];
}

function cleanSelectedFilters() {
  filtersSelected = filtersApplied.slice(0);
}

function addDealersAttribute(code) {
  dealersAttributes.push(code);
}

function getDealersAttributes() {
  return uniq(dealersAttributes);
}

function resetDealersAttributes() {
  dealersAttributes = [];
}

module.exports = {
  select: selectFilter,
  unselect: unselectFilter,
  filter: filterDealers,
  get: getFilters,
  getFilter: getFilter,
  reset: resetFilters,
  cleanSelectedFilters: cleanSelectedFilters,
  addDealersAttribute: addDealersAttribute,
  getDealersAttributes: getDealersAttributes,
  resetDealersAttributes: resetDealersAttributes,
};
